export default class HomeHeader {
	/**
	 * Entrypoint
	 */
	init() {
		// attach events
		this.bindEvents();
	}

	/**
	 * Bind component's events
	 */
	bindEvents() {}

	// // --------------------------------
	// // #region Event Handlers
	// // --------------------------------
}
